import "./scolarship-fields.style.css";
import ScholarshipInput from "./component/ScholarshipInput.js";
const ScholarshipFields = ({ scholarshipInfo, buttonStyle, termsStyle }) => {
  return (
    <ScholarshipInput
      scholarshipInfo={scholarshipInfo}
      buttonStyle={buttonStyle}
      termsStyle={termsStyle}
    />
  );
};

export default ScholarshipFields;
